import { render, staticRenderFns } from "./Contacts.html?vue&type=template&id=772da2fd&scoped=true&external"
import script from "./Contacts.js?vue&type=script&lang=js&external"
export * from "./Contacts.js?vue&type=script&lang=js&external"
import style0 from "./Contacts.scss?vue&type=style&index=0&id=772da2fd&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772da2fd",
  null
  
)

export default component.exports